module.exports = __webpack_public_path__ + "img/04-3-1系统演示.89968379.svg";